import { Component, Host, h, Prop, Event, EventEmitter, Listen } from '@stencil/core';
import state from './../../../state/cta-price';

@Component({
  tag: 'afs-buy-button',
  styleUrl: 'afs-buy-button.sass',
  shadow: true,
})
export class AfsBuyButton {

  @Prop() mainHrefFragment : string = "";
  @Prop() backgroundColor : string = "#222222";
  @Prop() color : string = "#FFFFFF";
  @Prop() href : string;
  @Prop() roundedEdge : boolean = false;
  @Prop() size : 'xs' | 's' | 'm' | 'l' | 'lxl' | 'xl' | '2xl' = "m";
  @Prop() sizeTablet : 'xs' | 's' | 'm' | 'l' | 'lxl' | 'xl' | '2xl';
  @Prop() exposed : boolean = false;

  @Event() buyButtonTriggered : EventEmitter;
  buyButtonTriggeredHandler() {
    let products;

    if (state.donationSelectedPricePoint !== null) {
        products = [...state.CTAPriceButtonStatus, state.donationSelectedPricePoint];
    } else {
        products = state.CTAPriceButtonStatus;
    }
    
    this.buyButtonTriggered.emit({
        mainHrefFragment: this.mainHrefFragment,
        products
    })
  }

  @Listen('click')
  function(e : PointerEvent) {
    if (!this.exposed) return;

    e.preventDefault();
    if (state.CTATotalPrice === 0) return;
    this.buyButtonTriggeredHandler();
  }

  render() {
    const hasTicketSelected = state.CTATotalPrice > 0;
    const buttonHref = this.exposed ? null : this.href ?? `${this.mainHrefFragment}?${ state.CTALink.join('&') }`;

    return (
      <Host>
        <afs-button
          style={{ 'opacity': hasTicketSelected ? '1' : '0.5' }}
          rounded-edge={this.roundedEdge} 
          size={this.size} 
          size-tablet={this.sizeTablet && this.sizeTablet} 
          background-color={this.backgroundColor} 
          color={this.color} 
          href={buttonHref} 
          disabled={state.CTATotalPrice === 0}
          target=""
        ><slot></slot></afs-button>
      </Host>
    );
  }

}
